import React from 'react';
import PropTypes from 'prop-types';
import { generateLinkTag, getAuthPlayerLinks } from 'helpers/AuthHelper';
import SearchInput from '../SearchInput';
import style from './ProviderSearchList.module.scss';

const ProviderSearchList = ({
  filteredList,
  handleChange,
  handleMVPDSelect,
  isFocused,
  mvpdList = [],
  searchQuery,
  setFilteredList,
  setIsFocused,
  setSearchQuery,
}) => {
  if (!mvpdList?.length) return null;

  const playerLinks = getAuthPlayerLinks();
  const { noProvider } = playerLinks;
  const noProviderTag = generateLinkTag(style, noProvider);

  return (
    <section className={style.root}>
      {mvpdList && (
        <>
          <SearchInput
            handleChange={handleChange}
            isFocused={isFocused}
            searchQuery={searchQuery}
            setFilteredList={setFilteredList}
            setSearchQuery={setSearchQuery}
            setIsFocused={setIsFocused}
          />
          {searchQuery && (
            <ul className={style.providerList}>
              {isFocused &&
                filteredList?.map(mvpd => {
                  const { id, adobePassId, name } = mvpd;
                  return (
                    <li key={id} data-adobepassid={adobePassId}>
                      <a onClick={() => handleMVPDSelect(adobePassId, name)}>{name}</a>
                    </li>
                  );
                })}
            </ul>
          )}
          {isFocused && filteredList?.length === 0 && (
            <div className={style.noResults}>No Results</div>
          )}
          {!searchQuery && <>{noProviderTag}</>}
        </>
      )}
    </section>
  );
};

export default ProviderSearchList;

ProviderSearchList.propTypes = {
  filteredList: PropTypes.shape([]),
  handleChange: PropTypes.func,
  handleMVPDSelect: PropTypes.func,
  isFocused: PropTypes.bool,
  mvpdList: PropTypes.shape([]),
  searchQuery: PropTypes.string,
  setFilteredList: PropTypes.func,
  setIsFocused: PropTypes.func,
  setSearchQuery: PropTypes.func,
};
